import { render } from "./Zones.vue?vue&type=template&id=228cf718&scoped=true"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"

import "./Zones.vue?vue&type=style&index=0&id=228cf718&lang=css"
import "./Zones.vue?vue&type=style&index=1&id=228cf718&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228cf718"]])

export default __exports__